/* eslint-disable react-hooks/exhaustive-deps */
import FileUpload from "components/FileUpload";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { addAppealRequest } from "services/appealService";
import { AppealRequest, DefendantAppeal } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";

type Props = {
  appeal?: DefendantAppeal;
  appealType: "ReAppealCase";
  // Request a cassation (instead of a re-appeal) from the defendant appeal.
  isCassation?: boolean;
  onClose: (refetch: boolean) => void;
};

const AppealRequestFromDefendantForm: FC<Props> = ({
  appeal,
  appealType,
  isCassation,
  onClose,
}) => {
  const navigate = useNavigate();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState<AppealRequest>({
    appeal_type: appealType,
    status: "PENDING",
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...(prevState ?? {}),
      [name]: value,
    }));
  };

  const handleFile = (file: File | null) => {
    setFormState((prevState) => ({
      ...(prevState ?? {}),
      appeal_summary_files: file,
    }));
  };

  const validateForm = () => {
    if (!formState?.appeal_summary_text) {
      return "Appeal summary is required.";
    }
    if (!formState?.appeal_summary_files) {
      return "Appeal file is required.";
    }
    // if (!formState?.defendant_ids || formState?.defendant_ids?.length === 0) {
    //   return "Defendant is required.";
    // }
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }
    setLoading(true);
    const data = {
      ...formState,
      is_cassation: isCassation ? true : undefined,
      case_id: appeal?.case?.id || undefined,
      defendant_appeal_request_id: appeal?.id?.toString(),
      opening_case_file: appeal?.case?.opening_case_files?.[0]?.id || null,
      bail_right_id: appeal?.bail_right?.uu_id || undefined,
    };

    addAppealRequest(data)
      .then(() => {
        showTooltip("Successfully Requested!", "success");
        navigate("/appeal");
        onClose(true);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandlerOnForm(error),
          "error"
        );
      })
      .finally(() => setLoading(false));
  };
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  useEffect(() => {
    if (appeal && appealType) {
      setFormState((prev) => ({
        ...prev,
        case_id: appeal?.case?.id ?? undefined,
        crime_registration_number:
          appeal?.case?.crime_refernce_number ||
          appeal?.bail_right?.crime_registration_number,
        incident_registration_number:
          appeal?.case?.incident_registration_no ||
          appeal?.bail_right?.incident_registration_number,
        prosecutor_registration_number:
          appeal?.case?.prosecutor_registration_number ||
          appeal?.bail_right?.prosecutor_registration_number,
        status: "PENDING",
        court_registration_number: appeal?.case?.opening_case_files
          ? appeal?.case?.opening_case_files?.[0]?.court_registration_number
          : appeal?.bail_right?.court_registration_number || "",

        reason: "",
        appeal_type: appealType,
        defendant_ids: appeal?.defendants
          ? appeal?.defendants?.map((i) => String(i?.id))
          : [],
        appeal_summary_file: null,
        appeal_summary_text: "",
        admin_unit_id: loginData?.admin_unit + "",
        org_unit_id: loginData?.org_unit + "",
        requesting_prosecutor_id: loginData?.user_id + "",
        // appeal?.crime_type ||

        bail_right_id: appeal?.bail_right?.uu_id,
        defendant_appeal_request_id: appeal?.id?.toString(),
      }));
    }
  }, [appealType, appeal]);

  // if (!finalVerdict && !count) return <></>;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <h2 className="mb-1 text-2xl font-semibold">Appeal Request</h2>
        <p className="mb-6 text-xs font-light text-[#9D9D9D]">
          Fill in the pre-judgement details below.
        </p>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            {/* <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Reason
              </label>
              <textarea
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="reason"
                value={formState?.reason ?? ""}
                onChange={handleChange}
                rows={4}
              />
            </div> */}
            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Appeal Summary
              </label>
              <textarea
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="appeal_summary_text"
                value={formState?.appeal_summary_text ?? ""}
                onChange={handleChange}
                rows={4}
              />
            </div>
            <div className="mt-4">
              <FileUpload
                label="Claim Summary Document"
                fileTypes="*"
                info="Upload Files"
                required={false}
                onChange={handleFile}
              />
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <button
              type="submit"
              className={`border border-[#212121] bg-[#212121] px-[76px] py-2 
                      text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]
                              ${
                                loading ? "opacity-50 cursor-not-allowed" : ""
                              }`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Request"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AppealRequestFromDefendantForm;
